namespace Areas.MyWorkflows {
    "use strict";

        export function dueDateColumn(cellElement, cellInfo) {
            const date = new Date(cellInfo.data.expectedCompletionDate);
            cellElement.html(Areas.formatDate(date));

            const pacificDate = getPacificTimeDate();

            if (date.valueOf() < pacificDate.valueOf())
            {
                $(cellElement).css('background-color', 'red');
            }
        }

        function getPacificTimeDate() {
            const now = new Date();
            // Convert to ISO format in Pacific Time
            const pacificTimeString = now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });

            // Create a Date object based on the Pacific Time string
            const pacificDate = new Date(pacificTimeString);
            return pacificDate;
        }

    }


